import React, { ComponentProps, FC } from 'react';

import SideNavigation from '@adsk/alloy-side-navigation';

import RemoteSideNavigationError from './RemoteSideNavigationError';
import RemoteSideNavigationLoader from './RemoteSideNavigationLoader';
import RemoteComponent from '../RemoteComponent/RemoteComponent';

type RemoteSideNavigationProps = {
  scope: string;
  module: string;
} & ComponentProps<typeof SideNavigation>;

const RemoteSideNavigation: FC<RemoteSideNavigationProps> = ({
  scope,
  module,
}) => (
  <RemoteComponent
    scope={scope}
    module={module}
    renderLoader={() => <RemoteSideNavigationLoader />}
    renderError={() => <RemoteSideNavigationError />}
  />
);

export default RemoteSideNavigation;
